import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import InfluencerSettingsDocumentUpload from '../influencer-settings-document-upload/InfluencerSettingsDocumentUpload';

import { __t, applyTranslations, t } from 'utils/language';
import { getPaymentDetailsCountryType } from 'utils/organization';

import './influencer-business-details-settings.scss';

import type { OrganizationSettingsForm } from 'types';

applyTranslations(require('../organizations-settings.i18n.json'));
applyTranslations(require('./influencer-business-details-settings-form.i18n.json'));

type StateProps = {
  isDocumentProofSectionEnabled: boolean
}

type OwnProps = {
  children?: React.ReactNode,
  values: OrganizationSettingsForm,
  centerAligned?: boolean,
  isBusinessDetailsMissing?: boolean
};

type Props = StateProps & OwnProps;

const ORG_MSG_KEY = 'organizations_settings';
const MSG_KEY = 'influencer_business_details_settings_form';

class InfluencerBusinessDetailsSettings extends React.Component<Props> {
  isEntrepreneur = () => {
    const { businessDetails } = this.props.values;
    return businessDetails.entrepreneur === true || businessDetails.entrepreneur === 'true';
  };

  renderMissingBusinessDetails(): React.ReactNode {
    return (
      <div className="influencer-business-details-settings__missing-details-container">
        <div className="influencer-business-details-settings__missing-error">
          {__t('influencer_business_details_settings_form.business_details_missing_copy')}
        </div>
        <div className="influencer-business-details-settings__missing-note">
          {__t('influencer_business_details_settings_form.business_details_missing_note')}
        </div>
      </div>
    );
  }

  render() {
    const {
      values,
      children,
      centerAligned,
      isBusinessDetailsMissing,
      isDocumentProofSectionEnabled } = this.props;
    const { businessDetails, billingAddress, proofDocuments } = values;

    if (isBusinessDetailsMissing) {
      return this.renderMissingBusinessDetails();
    }

    const document = proofDocuments?.businessDetailsProof || null;

    const rowClass = classnames('influencer-business-details-settings__row', {
      'influencer-business-details-settings__row--center-aligned': centerAligned
    });

    const countryType = getPaymentDetailsCountryType(
      billingAddress.country.toLowerCase().trim()
    );

    return (
      <div className="influencer-business-details-settings">
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {__t(`${MSG_KEY}.labels.company_name`)}
          </div>
          <div className="influencer-business-details-settings__value">
            {businessDetails.companyName}
          </div>
        </div>
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {__t(`${MSG_KEY}.labels.tax_registration_number`)}
          </div>
          <div className="influencer-business-details-settings__value">
            <div>{__t(`${MSG_KEY}.labels.dropdown_options.${businessDetails.taxIdCategory?.toLocaleLowerCase()}`)}</div>
            <div>{businessDetails.taxId}</div>
          </div>
        </div>
        {
          isDocumentProofSectionEnabled && (
            <div className={rowClass}>
              <div className="influencer-business-details-settings__label not-mandatory">
                {__t(`${MSG_KEY}.labels.tax_registration_document.title`)}
              </div>
              <div className="influencer-business-details-settings__value">
                <InfluencerSettingsDocumentUpload
                  title={__t(`${MSG_KEY}.labels.tax_registration_document.title`)}
                  info={__t(`${MSG_KEY}.labels.tax_registration_document.info`)}
                  uploadButtonLabel={__t(`${MSG_KEY}.labels.tax_registration_document.submit_btn`)}
                  document={document}
                  canEdit={false}
                  onDelete={() => null}
                  onPreUpload={() => null}
                />
              </div>
            </div>
          )
        }
        {
          countryType === 'germany' && (
            <div className={rowClass}>
              <div className="influencer-business-details-settings__label">
                {__t(`${ORG_MSG_KEY}.labels.entrepreneur`)}
              </div>
              <div className="influencer-business-details-settings__value">
                {String(businessDetails.entrepreneur) === 'true' ? 'Yes' : 'No'}
              </div>
            </div>
          )
        }
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {t('address_details_address_line_1')}
          </div>
          <div className="influencer-business-details-settings__value">
            {billingAddress.addressLine1}
          </div>
        </div>
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {t('address_details_city')}
          </div>
          <div className="influencer-business-details-settings__value">
            {billingAddress.city}
          </div>
        </div>
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {t('address_details_state')}
          </div>
          <div className="influencer-business-details-settings__value">
            {billingAddress.state || (<span>&mdash;</span>)}
          </div>
        </div>
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {t('address_details_postal_code')}
          </div>
          <div className="influencer-business-details-settings__value">
            {billingAddress.postalCode}
          </div>
        </div>
        <div className={rowClass}>
          <div className="influencer-business-details-settings__label">
            {t('address_details_country')}
          </div>
          <div className="influencer-business-details-settings__value">
            {billingAddress.country}
          </div>
        </div>
        {children}
      </div>
    );
  }
}

const mapStateToProps = ({ runtimeConfig }): StateProps => ({
  isDocumentProofSectionEnabled: runtimeConfig?.config?.settingsDocumentProofEnabled
});

export default connect(mapStateToProps)(InfluencerBusinessDetailsSettings);
